import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import { Wrapper, Content, ContainerText, Title } from "./styled"

const HeroAbout = () => {
  const { aboutImage } = useStaticQuery(
    graphql`
      query {
        aboutImage: file(relativePath: { eq: "hero-about.png" }) {
          childImageSharp {
            fluid(maxWidth: 600) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    `
  )

  return (
    <Wrapper Tag="div" fluid={aboutImage.childImageSharp.fluid}>
      <Content>
        <ContainerText>
          <Title>
            Quem somos e o que <span>nos move_</span>
          </Title>
        </ContainerText>
      </Content>
    </Wrapper>
  )
}

export default HeroAbout
